module.exports = __webpack_public_path__ + "img/the-new-saints-logo-icon.7a176abd.png";